// Dependencies
import {
  REPARTIDORES_REQUEST,
  REPARTIDORES_REFRESH,
  REPARTIDORES_OK,
  REPARTIDORES_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchRepartidores = () => async (dispatch) => {
  try {
    const response = await get("/repartidores");
    const data = response["data"];
    dispatch({
      type: REPARTIDORES_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: REPARTIDORES_ERROR, payload: error });
    return Promise.reject();
  }
};

export const getRepartidores = () => (dispatch) => {
  dispatch({ type: REPARTIDORES_REQUEST });
  return dispatch(fetchRepartidores());
};

export const refreshRepartidores = () => (dispatch) => {
  dispatch({ type: REPARTIDORES_REFRESH });
  return dispatch(fetchRepartidores());
};
